

export class EmployeeDetailsSelectActiveDataOutput implements IEmployeeDetailsSelectActiveDataOutput {
    /** The auto-generated id of the employee details master */
    employee_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The vehicle number with 50 character limit */
    vehicle_number!: string;
    /** The employee name */
    name!: string;
    /** The employee number with 13 character limit */
    employee_number!: string;
    /** The employee rfid  tag with 50 character limit */
    rfid_tag!: string;
    /** The designation name with 13 character limit */
    designation_name!: string;
    /** The zip code with 13 character limit */
    contact_number_1!: string;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The date of birth with 10 character limit */
    date_of_birth!: string;
    /** The driving experience of employee */
    driving_experience!: number;
    /** The list of employee license to drive */
    license_to_drive!: string;
    /** The employee photo with 2048 character limit */
    employee_photo!: string;
    /** Manage status of employee details. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IEmployeeDetailsSelectActiveDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_details_id = _data["employee_details_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.vehicle_number = _data["vehicle_number"];
            this.name = _data["name"];
            this.employee_number = _data["employee_number"];
            this.rfid_tag = _data["rfid_tag"];
            this.designation_name = _data["designation_name"];
            this.contact_number_1 = _data["contact_number_1"];
            this.state_name = _data["state_name"];
            this.date_of_birth = _data["date_of_birth"];
            this.driving_experience = _data["driving_experience"];
            this.license_to_drive = _data["license_to_drive"];
            this.employee_photo = _data["employee_photo"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EmployeeDetailsSelectActiveDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsSelectActiveDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_details_id"] = this.employee_details_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["vehicle_number"] = this.vehicle_number;
        data["name"] = this.name;
        data["employee_number"] = this.employee_number;
        data["rfid_tag"] = this.rfid_tag;
        data["designation_name"] = this.designation_name;
        data["contact_number_1"] = this.contact_number_1;
        data["state_name"] = this.state_name;
        data["date_of_birth"] = this.date_of_birth;
        data["driving_experience"] = this.driving_experience;
        data["license_to_drive"] = this.license_to_drive;
        data["employee_photo"] = this.employee_photo;
        data["status"] = this.status;
        return data; 
    }
}

export interface IEmployeeDetailsSelectActiveDataOutput {
    /** The auto-generated id of the employee details master */
    employee_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The vehicle number with 50 character limit */
    vehicle_number: string;
    /** The employee name */
    name: string;
    /** The employee number with 13 character limit */
    employee_number: string;
    /** The employee rfid  tag with 50 character limit */
    rfid_tag: string;
    /** The designation name with 13 character limit */
    designation_name: string;
    /** The zip code with 13 character limit */
    contact_number_1: string;
    /** The state name with 255 character limit */
    state_name: string;
    /** The date of birth with 10 character limit */
    date_of_birth: string;
    /** The driving experience of employee */
    driving_experience: number;
    /** The list of employee license to drive */
    license_to_drive: string;
    /** The employee photo with 2048 character limit */
    employee_photo: string;
    /** Manage status of employee details. 0 For De-active, 1 For Active */
    status: number;
}

